export default __webpack_public_path__ + "static/media/switch-to-full-screen-button.19f48641.svg";